import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class ChangeDetectedOrganizationTypeService {

  // Observable message source
  private messageSource = new Subject<void>();


  // Observable message stream
  messageSent$ = this.messageSource.asObservable();

  changeDetected() {
    this.messageSource.next();
  }

}
